/* eslint-disable max-lines */
import React from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Bullet, useI18n } from '@popety_io/popety-io-lib'
import { getConfidenceValue, scoreBullet } from './utils'

interface PriceSourcesLegendProps {
  sources: any
}

export const PriceSourcesLegend: React.FC<PriceSourcesLegendProps> = ({
  sources,
}) => {
  const { t } = useI18n()

  return (
    <Box
      sx={{
        width: '90%',
        display: 'flex',
        flexWrap: 'wrap',
        mt: '10px',
        zIndex: 9,
        gap: 2,
        justifyContent: 'space-around',
        position: 'relative',
      }}
    >
      {sources?.map((source: any) => (
        <Box
          key={source.name}
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                color: source.color,
                fontWeight: 500,
              }}
            >
              {source.name !== 'Announces'
                ? source.name
                : t(`estimate.${source.name}`)}
            </Typography>
            {source.description && (
              <Tooltip title={t(`estimate.${source.description}`)} arrow>
                <InfoOutlinedIcon
                  sx={{
                    fontSize: 16,
                    color: source.color,
                    cursor: 'pointer',
                  }}
                />
              </Tooltip>
            )}
          </Box>
          {source.name !== 'Announces' && (
            <Box sx={{ color: source.color }}>
              <Bullet
                data={scoreBullet}
                value={getConfidenceValue(source.confidence)}
                isHover={false}
              />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  )
}

export default PriceSourcesLegend
